module.exports = __webpack_public_path__ + "fc05889fa8167b8ba06fa09f8698cf7d.png";